import React, { useState } from 'react';
import { ContractList } from './ContractList';
import { ContractForm } from './ContractForm';
import { ContractTypes } from './ContractTypes';
import { ContractVariations } from './ContractVariations';
import { ContractAmendments } from './ContractAmendments';
import { ContractMilestones } from './ContractMilestones';
import { ContractPaymentClaims } from './ContractPaymentClaims';
export function ContractManagement({
  locale,
  currentView,
  setCurrentView
}) {
  const [selectedContract, setSelectedContract] = useState(null);
  // Determine which component to render based on the current view
  const renderContent = () => {
    switch (currentView) {
      case 'contract-types':
        return <ContractTypes locale={locale} data-id="element-2668" />;
      case 'add-contract':
        return <ContractForm locale={locale} onSelectContract={setSelectedContract} data-id="element-2669" />;
      case 'contract-detail':
        return <ContractList locale={locale} onSelectContract={setSelectedContract} data-id="element-2670" />;
      case 'contract-variations':
        return <ContractVariations locale={locale} data-id="element-2671" />;
      case 'contract-amendments':
        return <ContractAmendments locale={locale} data-id="element-2672" />;
      case 'contract-milestones':
        return <ContractMilestones locale={locale} data-id="element-2673" />;
      case 'contract-payment-claims':
        return <ContractPaymentClaims locale={locale} data-id="element-2674" />;
      case 'contract-management':
        // Default dashboard view
        return <div data-id="element-2675">
            <div className="mb-8" data-id="element-2676">
              <h2 className="text-2xl font-bold text-gray-900" data-id="element-2677">
                Contract Management
              </h2>
              <p className="mt-1 text-sm text-gray-500" data-id="element-2678">
                Manage all aspects of your contracts, from creation to
                completion
              </p>
            </div>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-2679">
              {/* Quick access cards */}
              <div onClick={() => setCurrentView('contract-detail')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2680">
                <div className="p-5" data-id="element-2681">
                  <div className="flex items-center" data-id="element-2682">
                    <div className="flex-shrink-0 bg-indigo-500 rounded-md p-3" data-id="element-2683">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2684">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" data-id="element-2685" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2686">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2687">
                        Contract List
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2688">
                        View and manage all contracts
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('add-contract')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2689">
                <div className="p-5" data-id="element-2690">
                  <div className="flex items-center" data-id="element-2691">
                    <div className="flex-shrink-0 bg-green-500 rounded-md p-3" data-id="element-2692">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2693">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" data-id="element-2694" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2695">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2696">
                        Add Contract
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2697">
                        Create a new contract
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('contract-variations')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2698">
                <div className="p-5" data-id="element-2699">
                  <div className="flex items-center" data-id="element-2700">
                    <div className="flex-shrink-0 bg-purple-500 rounded-md p-3" data-id="element-2701">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2702">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" data-id="element-2703" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2704">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2705">
                        Variations
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2706">
                        Manage contract variations
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('contract-amendments')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2707">
                <div className="p-5" data-id="element-2708">
                  <div className="flex items-center" data-id="element-2709">
                    <div className="flex-shrink-0 bg-yellow-500 rounded-md p-3" data-id="element-2710">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2711">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" data-id="element-2712" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2713">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2714">
                        Amendments
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2715">
                        Track contract amendments
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('contract-milestones')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2716">
                <div className="p-5" data-id="element-2717">
                  <div className="flex items-center" data-id="element-2718">
                    <div className="flex-shrink-0 bg-blue-500 rounded-md p-3" data-id="element-2719">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2720">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" data-id="element-2721" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2722">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2723">
                        Milestones
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2724">
                        Track contract milestones
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('contract-payment-claims')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2725">
                <div className="p-5" data-id="element-2726">
                  <div className="flex items-center" data-id="element-2727">
                    <div className="flex-shrink-0 bg-red-500 rounded-md p-3" data-id="element-2728">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2729">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" data-id="element-2730" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2731">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2732">
                        Payment Claims
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2733">
                        Manage payment claims
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div onClick={() => setCurrentView('contract-types')} className="bg-white overflow-hidden shadow rounded-lg cursor-pointer hover:shadow-md transition-shadow" data-id="element-2734">
                <div className="p-5" data-id="element-2735">
                  <div className="flex items-center" data-id="element-2736">
                    <div className="flex-shrink-0 bg-gray-500 rounded-md p-3" data-id="element-2737">
                      <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-2738">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" data-id="element-2739" />
                      </svg>
                    </div>
                    <div className="ml-5" data-id="element-2740">
                      <h3 className="text-lg font-medium text-gray-900" data-id="element-2741">
                        Contract Types
                      </h3>
                      <p className="text-sm text-gray-500" data-id="element-2742">
                        Manage contract types
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>;
      default:
        return <ContractList locale={locale} onSelectContract={setSelectedContract} data-id="element-2743" />;
    }
  };
  return <div data-id="element-2744">
      {selectedContract ? <ContractForm locale={locale} contract={selectedContract} onSelectContract={setSelectedContract} data-id="element-2745" /> : renderContent()}
    </div>;
}